import React from 'react';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {observer} from "mobx-react";
import {action, observable} from "mobx";
import mdEntityService from "core/metamodel/mdEntityService";
import {DialogAncestor} from "core/common/page/dialogAncestor";
import {LovItem} from "core/metamodel/mdEntity";
import {UILOCATION} from "core/grid/component/gridComp";
import GridComp from 'core/grid/component/gridComp';
import Grid, {GridRow} from "core/grid/domain/grid";
import gridService from "core/grid/gridService";
import {ID} from "core/metamodel/metaConstant";
import {DomainAncestor} from "../../common/domain/DomainAncestor";


interface SelectSearchDialogProps {
  gridLocation: string;
  masterId?: ID;
  contentStyle?: any;
  showGridConfig?: boolean;
  title?: string;
  showOk?: boolean;
}

@observer
export default class SelectSearchDialog extends DialogAncestor<SelectSearchDialogProps, undefined, LovItem | DomainAncestor | DomainAncestor[]> {

  @observable private grid: Grid;

  @observable private selected: Map<ID, DomainAncestor>;

  @observable private title: string;

  @action open(resolve, reject, gridSearchModifierFn?: (grid: Grid) => void, title?: string, masterId?: string): Promise<any> {
    this.resolve = resolve;
    this.reject = reject;
    this.selected = new Map();
    this.dialogOpen = true;
    this.title = title;
    return gridService.fetchGrids(this.props.gridLocation)
      .then(gridLocationMap => {
        this.grid = new Grid(gridLocationMap.get(this.props.gridLocation), masterId ? masterId : this.props.masterId);
        if (gridSearchModifierFn) gridSearchModifierFn(this.grid);
        return gridService.search(this.grid);
      })
  }

  @action selectObject = (rowId: ID, item: GridRow) => {
    console.log('selectObject %s .. %O', rowId, item);
    return mdEntityService.getLovItem(this.grid.$entityRef.id, rowId)
      .then((lv: LovItem) => {
        this.dialogOpen = false;
        this.resolve(lv);
      });
  };

  @action selectObjectFullJson = (rowId: ID, item: GridRow) => {
    console.log('selectObjectFullJson %s .. %O', rowId, item);
    this.dialogOpen = false;
    this.resolve(item.rowObject as any);
  };

  @action getCheckbox = (rowId: ID, item: GridRow): boolean => {
    let result = (!!this.selected.get(rowId + ""));
    return result;
  };

  @action setCheckbox = (rowId: ID, item: GridRow, checked: boolean) => {
    console.log('setCheckbox %s .. %O ... %s', rowId, item, checked);
    if (checked) {
      this.selected.set(rowId + "", item.rowObject);
    } else {
      this.selected.delete(rowId + "");
    }
    this.forceUpdate();
  };


  @action cancel = (evt) => {
    console.log('SelectSearchDialog#cancel evt = %O', evt);
    this.dialogOpen = false;
    this.$errors = [];

    this.reject("cancel");
  };

  @action ok = (evt) => {
    console.log('SelectSearchDialog#ok selected = %O', this.selected);
    this.dialogOpen = false;
    this.$errors = [];

    this.resolve(Array.from(this.selected.values()));
  };


  render() {
    if (!(this.grid && this.dialogOpen)) return null;

    let {title, showGridConfig, contentStyle, showOk} = this.props;

    let finalTitle = this.title ? this.title : (title?title:"Search");

    let actions = [<FlatButton key="0" label="Cancel" primary onClick={this.cancel}/>];

    if (showOk) {
      actions.unshift(<FlatButton label="OK" secondary onClick={this.ok}/>)
    }

    return (
      <Dialog
        title={finalTitle}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        contentStyle={contentStyle}
      >

        <GridComp grid={this.grid} multiSelect={false} hideGridConfig={!showGridConfig}
                  uiLocation={UILOCATION.dialog} bodyStyle={{paddingBottom: 7}}
                  functionMap={{
                    selectObject: this.selectObject.bind(this),
                    selectObjectFullJson: this.selectObjectFullJson.bind(this),
                    getCheckbox: this.getCheckbox.bind(this),
                    setCheckbox: this.setCheckbox.bind(this) }}
                  entities={mdEntityService.entityMap}/>


      </Dialog>
    );
  }

}




// WEBPACK FOOTER //
// ./src/core/components/fields/selectSearchDialog.tsx